module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "dialog-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-menu",
    on: {
      "click": _vm.close
    }
  }, [_c('div', {
    staticClass: "dialog-ctx",
    class: _vm.list.length > 6 ? 'dialog-low' : ''
  }, [_c('div', {
    staticClass: "cont"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "menu-item"
    }, [(item.img != undefined) ? _c('img', {
      staticClass: "sub-img",
      attrs: {
        "src": item.img
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.menuClick(item)
        }
      }
    }, [_c('div', {
      staticClass: "menu-title"
    }, [_c('span', [_vm._v(_vm._s(item.menuName))])]), _vm._v(" "), _c('span', {
      staticClass: "menu-desc"
    }, [_vm._v(_vm._s(item.desc))])]), _vm._v(" "), (item.miniId != undefined) ? _c('wx-open-launch-weapp', {
      class: 'launch-btn',
      staticStyle: {
        "height": "60px",
        "width": "100%",
        "position": "absolute",
        "top": "0",
        "left": "0",
        "z-index": "10"
      },
      attrs: {
        "id": 'launch-btn-b-' + index,
        "username": item.miniId,
        "path": item.url
      }
    }, [_c('script', {
      attrs: {
        "type": "text/wxtag-template"
      }
    }, [_vm._v("\n                                <div style=\"height: 2rem;width: 2rem;opacity: 0\"></div>\n                            ")])]) : _vm._e()], 1)
  })], 2), _vm._v(" "), (_vm.list[0].self == undefined && _vm.list[0].miniId == undefined) ? _c('div', {
    staticClass: "remark"
  }, [_vm._v("本服务来源于湖南一次事一次办平台")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fab0ee8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/provincial_level/detail_dialog/detail_dialog.vue
// module id = 323
// module chunks = 40